<template>
  <div class="">
    <div>
      <input type="file" id="select_multiple_image" name="select_multiple_image" multiple accept="image/*"
             class="d-none" @input="onFileChange">
      <label for="select_multiple_image">
        <b-img v-bind="picProps" rounded class="card"></b-img>
      </label>
    </div>
    <div>
      <b-row class="mb-2">
        <b-col
            v-for="(file, index) in previews"
            :key="index"
            sm="2"
            md="2"
            class="mb-2"
        >
          <b-img v-bind="picProps" :src="file" class="card"/>
          <button @click="removeImage(index)" type="button"
                  class="btn btn-danger btn-sm text-center rounded-pill mt-1 ">
            <span class="badge rounded-pill">حذف عکس</span>
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultiImageInput",
  props: ["previews", 'imagesSelector'],
  data() {
    return {
      previewImages: this.preview,
      picProps: {
        blankColor: "#fff",
        width: 75,
        height: 75,
        class: "m1",
      },
    };
  },
  model: {
    prop: 'imagesSelector',
    event: 'input'
  },
  methods: {
    removeImage(index) {
      // if have selected item(index) in images we remove it from server.

      const removeItemFromServe = this.previews[index].indexOf('blob') === -1;

      const images = Array.from(this.imagesSelector).filter(function (item, item_index) {
        return item_index !== index
      });

      this.previews.splice(index, 1);
      this.$emit('input', images)

      if (removeItemFromServe) {
        this.$store.dispatch("Product/deleteImage", index)
            .then(res => {
              this.$emit('removeImage', true)
            })
            .catch((error) => {
              console.log(error);
            })

      }

    },
    onFileChange(e) {
      // show selected image preview before upload
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        this.previews.push(URL.createObjectURL(file));
      }
      this.$emit('input', e.target.files)
    },
  },
}
</script>

<style scoped>

</style>